import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import { FaHospital, FaGlobeAfrica, FaUserClock } from "react-icons/fa";

export default function HomeBanner2(props) {

	const appContext = useContext(AppContext);
	const [ready, setReady] = useState(false);

	async function init() {
		setReady(false);
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-primary text-white"
				style={{ paddingTop: "50px", paddingBottom: "50px" }}
			>
				<div className="container">
					
					<div className="row">
						<div className="col-md-12 text-center">
							<h1
								style={{ fontSize: "22px", paddingTop: "30px", paddingBottom: "30px" }}
								className="font-light"
							>
								<span
									style={{ fontSize: "48px" }}
									className="font-bold d-block"
								>
									Caremed Gas Ltd
								</span>
								is one of the key importers, distributors and sellers of Medical Oxygen
								Equipment and Plants, and maintenance of Medical equipment, Medical Oxygen Devices,
								Analytical Laboratories and Instruments in Tanzania. The company also deals with installation
								and maintenance of Medical Equipment.
							</h1>

							<div className="text-center mt-4">
								<button
									className="btn btn-padded btn-rounded btn-light"
									onClick={() => appContext.navTo({ item: 'about_us' })}
								>
									About Us
								</button>
							</div>
						</div>
					</div>

					{/* Stats Section */}
					<div className="row mt-5 text-center">
						
						<div className="col-md-4 mb-4">
							<div className="p-4 rounded-4 bg-white bg-opacity-10 shadow-sm h-100">
								<FaUserClock className="display-4 mb-3 text-warning" />
								<h2 className="fw-bold fs-1">7+</h2>
								<p className="fs-5 mb-0">Years Experience</p>
							</div>
						</div>

						<div className="col-md-4 mb-4">
							<div className="p-4 rounded-4 bg-white bg-opacity-10 shadow-sm h-100">
								<FaGlobeAfrica className="display-4 mb-3 text-success" />
								<h2 className="fw-bold fs-1">4+</h2>
								<p className="fs-5 mb-0">Countries Served</p>
							</div>
						</div>

						<div className="col-md-4 mb-4">
							<div className="p-4 rounded-4 bg-white bg-opacity-10 shadow-sm h-100">
								<FaHospital className="display-4 mb-3 text-info" />
								<h2 className="fw-bold fs-1">20+</h2>
								<p className="fs-5 mb-0">Hospitals Supported</p>
							</div>
						</div>

					</div>
				</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
